<h1>Albion Online Market Prices Favorites</h1>
@if (!(authService.user$ | async)) {
  <div>
    You need to <button mat-flat-button color="accent" (click)="authService.googleSignIn()"><mat-icon>login</mat-icon>LOGIN</button> to use this tool.
  </div>
}

@if (authService.user$ | async) {
  @if (shopCategories && items && !isLoading) {
    <div class="flex-container-column">
      @if (!createdFavoriteList) {
        <app-text-divider>FAVORITES LISTS</app-text-divider>
        <div class="form-container vertical-center">
          <button mat-mini-fab color="primary" matTooltip="Create New List" (click)="startCreatingList()" aria-label="Create List">
            <mat-icon>add</mat-icon>
          </button>
          @if (selectedFavoriteList) {
            <button mat-mini-fab color="primary" matTooltip="Edit Selected List" (click)="startEditingList()" aria-label="Edit List">
              <mat-icon>edit</mat-icon>
            </button>
          }
          @if (selectedFavoriteList) {
            <button mat-mini-fab color="warn" matTooltip="Delete Selected List" (click)="deleteList()" [disabled]="loadingBarService.getDisableFastAPIButtons()" aria-label="Delete List">
              <mat-icon>delete</mat-icon>
            </button>
          }
          <mat-form-field class="form-item-medium" appearance="fill">
            <mat-label>{{ userSettingsService.getUserPriceFavoritesLists().length > 0 ? 'Select a list' : 'No lists yet' }}</mat-label>
            <mat-select [value]="selectedFavoriteList" (selectionChange)="selectedListChanged($event)">
              <mat-option [value]="null">None</mat-option>
              @for (favorite of userSettingsService.getUserPriceFavoritesLists(); track favorite) {
                <mat-option [value]="favorite">
                  {{ favorite.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <button
            class="form-item-button"
            style="align-self: auto"
            mat-mini-fab
            (click)="refreshPrices()"
            [disabled]="(!(this.prices$ | async) && !(this.histories$ | async)) || loadingBarService.getDisableSlowAPIButtons()"
            color="primary"
            aria-label="Clear All Button"
            matTooltip="Refresh Prices"
          >
            <mat-icon>refresh</mat-icon>
          </button>
          <button
            class="form-item-button"
            style="align-self: auto"
            mat-mini-fab
            (click)="exportPricesCsv()"
            [disabled]="!selectedFavoriteList && !(prices$ | async)?.length && !(histories$ | async)?.length"
            color="primary"
            matTooltip="Export Prices Csv"
            aria-label="Export Prices Csv"
          >
            <mat-icon>ios_share</mat-icon>
          </button>
          <mat-form-field class="form-item-medium" appearance="fill">
            <mat-label>Price Type</mat-label>
            <mat-select [(value)]="selectedPriceType">
              @for (type of priceTypes; track type) {
                <mat-option [value]="type">
                  {{ type.friendlyName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="form-item-medium">
            <mat-label>Number of Days for Average</mat-label>
            <input matInput [(ngModel)]="numberOfDaysForAverage" type="number" step="1" min="3" max="30" />
          </mat-form-field>
        </div>
      }
      @if (createdFavoriteList) {
        <app-text-divider>CREATE/EDIT FAVORITES LIST</app-text-divider>
        <div class="form-container vertical-center">
          <div>
            <mat-form-field class="form-item-medium">
              <mat-label>List Name</mat-label>
              <input matInput [(ngModel)]="createdFavoriteList.name" type="text" />
            </mat-form-field>
            <button
              mat-mini-fab
              color="primary"
              matTooltip="Save"
              [disabled]="!(createdFavoriteList.itemsIds.length > 0 && createdFavoriteList.name) || loadingBarService.getDisableSlowAPIButtons()"
              (click)="saveCreatedList()"
              aria-label="Save Created List"
            >
              <mat-icon>save</mat-icon>
            </button>
            <button mat-mini-fab color="primary" matTooltip="Cancel" (click)="cancelCreation()" aria-label="Cancel">
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
        </div>
        <app-text-divider>SELECT ITEMS TO ADD TO THE LIST</app-text-divider>
        <div class="form-container vertical-center">
          <div>
            <app-item-selector
              class="form-container-inline"
              [shopCategories]="shopCategories"
              [items]="items"
              [showItemSelector]="true"
              [(selectedCategory)]="selectedCategory"
              [(selectedSubCategory)]="selectedSubCategory"
              [(selectedTier)]="selectedTier"
              [(selectedItem)]="selectedItem"
            >
            </app-item-selector>
          </div>
        </div>
        <app-text-divider>{{ 'LIST ITEMS (' + createdFavoriteList.itemsIds.length + '/' + maxItems + ')' }}</app-text-divider>
        @for (item of createdFavoriteList.itemsIds; track item) {
          <div style="display: flex; justify-content: left; align-items: center; padding-bottom: 5px">
            <button mat-mini-fab color="warn" matTooltip="Delete Item From List" (click)="removeListItem(item)" aria-label="Delete Item from List">
              <mat-icon>delete</mat-icon>
            </button>
            <span>{{ jsonReaderService.getItemFromIndex(item)?.localizedName }}</span>
          </div>
        }
      }
      @if (selectedFavoriteList) {
        <app-text-divider>PRICES</app-text-divider>
        <app-locations-legend style="margin: 10px 0px"></app-locations-legend>
        <div class="price-card-container">
          @for (item of this.filterItemsForPrices(this.items); track item) {
            <div>
              <app-item-price-card
                [item]="item"
                [prices]="filterPricesForCard(item, prices$ | async)"
                [histories]="histories$ | async"
                [numberOfDaysAverage]="numberOfDaysForAverage"
                [imageUrl]="getItemImageUrl(item)"
                [showQualityLegend]="true"
                [priceType]="selectedPriceType"
              />
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <mat-spinner></mat-spinner>
  }
}
